import React, { Fragment, useState } from 'react';
import { useTranslate, Button } from 'react-admin';
import { useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import SvgIcon from '@material-ui/core/SvgIcon';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

import { FlashIcon } from '~/img';
import { Drawer, PhoneNumberInput } from '~/components';
import { Employee } from '~/types';
import { createAccessCode } from '~/api/employees';
import onError from '~/errorsHandler';
import { label } from '../EmployeeList';
import { usePermissions } from 'react-admin';
import useCrudGetManyReference from '~/hooks/useCrudGetManyReference';
import { crudGetOne } from 'react-admin';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: theme.spacing(4),
    paddingBottom: theme.spacing(3),
  },
  warningColor: {
    color: theme.palette.warning.main,
  },
  accessCode: {
    paddingBottom: theme.spacing(3),
  },
}));

interface Props {
  employeeRecord: Employee;
  isRefetchOne?: boolean;
}

const GetAccessCode = (props: Props) => {
  const { employeeRecord, isRefetchOne = false } = props;
  const employeeLinkedPhone = employeeRecord.phoneNumber;
  const { permissions } = usePermissions();

  const [loading, setLoading] = useState(false);
  const [accessCode, setAccesssCode] = useState('');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [phone, setPhone] = useState(employeeLinkedPhone || '');
  const handlePhone = (value: string) => setPhone(value);

  const crudGetManyReference = useCrudGetManyReference(
    'employees',
    'businesses',
    employeeRecord.businessId
  );
  const dispatch = useDispatch();

  const handleAccessCode = async () => {
    setLoading(true);
    try {
      const { data } = await createAccessCode(employeeRecord.id, phone);
      isRefetchOne
        ? dispatch(crudGetOne('employees', employeeRecord.id, '/employees'))
        : crudGetManyReference();
      setAccesssCode(data.accessCode);
    } catch (error) {
      onError(error);
    }
    setLoading(false);
  };

  const translate = useTranslate();
  const translateLabel = (key: string): string => translate(label(key));

  const classes = useStyles();

  return (
    <Fragment>
      <Button
        label={translateLabel('getAccessCode')}
        onClick={handleOpen}
        className={classes.warningColor}
        disabled={!permissions?.includes('business.employee.update')}
      >
        <SvgIcon>
          <FlashIcon />
        </SvgIcon>
      </Button>
      <Drawer
        heading={`${translateLabel('getAccessCodeFor')} ${employeeRecord.firstName || ''} ${
          employeeRecord.lastName || ''
        }`}
        open={open}
        onClose={handleClose}
      >
        <Grid container spacing={2} direction='column'>
          <Grid item>
            <PhoneNumberInput
              label={translateLabel('phoneSmsCode')}
              value={phone}
              onChange={handlePhone}
              fullWidth
            />
          </Grid>
          <Grid item>
            <Button
              label={translateLabel('getAccessCode')}
              variant='contained'
              onClick={handleAccessCode}
              loading={loading}
            >
              <SvgIcon>
                <FlashIcon />
              </SvgIcon>
            </Button>
          </Grid>
        </Grid>
        <Drawer
          heading={`${translateLabel('getAccessCodeFor')} ${employeeRecord.firstName || ''} ${
            employeeRecord.lastName || ''
          }`}
          open={!!accessCode}
          onClose={() => setAccesssCode('')}
        >
          <Typography variant='h3' className={classes.accessCode}>
            {accessCode}
          </Typography>
          <Typography variant='body2'>{translateLabel('accessCodeMessage')}</Typography>
        </Drawer>
      </Drawer>
    </Fragment>
  );
};

export default GetAccessCode;
